import React from 'react';
import { ImageSkeleton } from './ImageSkeleton';

export interface SkeletonLoaderProps {
	children?: React.ReactNode;
	height?: number | string;
	width?: number | string;
	id?: string;
	text?: string;
}

export const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
	children,
	height,
	width,
	id,
	text = ''
}: SkeletonLoaderProps): JSX.Element => {
	return React.Children.count(children) === 0 ? (
		<ImageSkeleton id={id} height={height} width={width} text={text} />
	) : (
		<>{children}</>
	);
};
